import { createContext, useContext, useState } from 'react';
import { observable } from 'mobx';

import CommonStore from './CommonStore';
import AuthStore from './AuthStore';
import UserStore from './UserStore';
import CourtStore from './CourtStore';
import CarouselStore from './CarouselStore';

export const store = {
    commonStore: new CommonStore(),
    authStore: new AuthStore(),
    userStore: new UserStore(),
    courtStore: new CourtStore(),
    carouselStore: new CarouselStore(),
};

export const StoreContext = createContext<typeof store>(store);
export const StoreProvider = StoreContext.Provider;

export function useStore() {
    return useContext(StoreContext);
}

export function useLocalStore<T extends Record<string, any>>(initialState: T): { localStore: T } {
    return {
        localStore: useState<T>(() => observable(initialState, undefined, { autoBind: true }))[0],
    };
}
